<script>
// import axios from "axios";

// import Layout from "../../layouts/auth";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
// import { mapState, mapGetters } from "vuex";
import 'boxicons/css/boxicons.min.css';
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
/**
 * Login component
 */

export default {
  page: {
    title: "Inicio de sesión",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    // Layout,
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  validations: {
    email: {
      required,
    },
    password: {
      required,
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),

    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    async tryToLogIn() {
      const { email, password } = this;
      await this.login({ email, password });
      // location.reload();
    },
    onValidate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.tryToLogIn();
      }
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    // console.log(usuario);
    if (usuario === "" || usuario === null || usuario === "null" || usuario.token === undefined) {
      this.logout();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: {
          "x-token":  usuario.token,
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
        });
    }
  },
};
</script>

<template>
  <div class="login-container">
    <div class="login-card">
      <div class="logo-container">
        <div class="logo-container">
          <img src="@/assets/logo.png" alt="Logo Multirepuestos San José" class="logo-img">
        </div>
      </div>
      
      <h2 class="welcome-text">Bienvenido de nuevo</h2>
      
      <b-alert
        v-model="isAuthError"
        variant="danger"
        class="mt-3"
        dismissible
      >{{ authError }}</b-alert>
      
      <div
        v-if="notification.message"
        :class="'alert ' + notification.type"
      >
        {{ notification.message }}
      </div>

      <b-form @submit.prevent="onValidate" class="login-form">
        <b-form-group
          label="Usuario"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="email"
            type="text"
            placeholder="Ingrese el usuario"
            :class="{ 'is-invalid': submitted && $v.email.$error }"
          ></b-form-input>
          <div
            v-if="submitted && $v.email.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.email.required">El usuario es necesario.</span>
          </div>
        </b-form-group>

        <b-form-group
          label="Contraseña"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="password"
            type="password"
            placeholder="Ingrese la contraseña"
            :class="{ 'is-invalid': submitted && $v.password.$error }"
          ></b-form-input>
          <div
            v-if="submitted && !$v.password.required"
            class="invalid-feedback"
          >
            La contraseña es necesaria.
          </div>
        </b-form-group>
        
        <b-button type="submit" variant="primary" class="submit-btn">
          Iniciar Sesión
        </b-button>
      </b-form>
    </div>
    
    <footer class="footer-text">
      © {{ new Date().getFullYear() }} Multi Repuestos San Jose. Innovación Continua.
      Todos los derechos reservados.
    </footer>
  </div>
</template>

<style scoped>
.logo-img {
  width: 100%;
  max-width: 250px;
  height: auto;
  margin-bottom: 1rem;
}
.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}
.login-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 450px;
}

.logo-container {
  text-align: center;
  margin-bottom: 1.5rem;
}

.logo-container i {
  font-size: 4rem;
  color: #4a90e2;
}

.welcome-text {
  text-align: center;
  color: #333;
  margin-bottom: 1.5rem;
}


.login-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.submit-btn {
  margin-top: 1.5rem;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.footer-text {
  margin-top: 2rem;
  text-align: center;
  color: #666;
  font-size: 0.9rem;
}
@media (max-width: 768px) {
  .login-card {
    max-width: 90%;
    padding: 1.5rem;
  }
  
  .logo-img {
    max-width: 200px;
  }
}
</style>
